import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Dropdown } from 'react-bootstrap';
import { HeaderWrapper } from './style';
import { BsBell, BsCheckCircleFill } from 'react-icons/bs';
import { BiChevronDown } from 'react-icons/bi';
import { FiLogOut } from 'react-icons/fi';
import { AiOutlineMenu } from 'react-icons/ai';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { stopImpersonatingUser, SignOut, setAuthState } from '../../slices/auth';
import axios from '../../../axios_config';
import { isEmpty } from 'lodash';
import HamburgerIcon from '../menu-button/menu-button.component.jsx';
import MenuDropDown from '../menu-dropdown/menu-dropdown.component.jsx';
import { AnimatePresence } from 'framer-motion';
import { Icon, Tooltip } from 'antd';
import { TabName } from '../menu-dropdown/menu-dropdown.styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { STORAGE_IMAGE_URL } from '../../constants/storage';
import { STORAGE_KEY } from '../../constants/onBoarding';
const Logo = `${STORAGE_IMAGE_URL}/opulentLogo.png`;

const Header = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser, parentUser, isImpersonatedCurrentUser, token } = useSelector(state => state?.auth || {});

  const [isDropdownShown, setIsDropdownShown] = useState(false);
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
  const [navbarClicked, setNavbarClicked] = useState('');
  const [zIndex, setZIndex] = useState(0);

  const { login, onClick, setMakeBlur, disabled, onTop, isTransparent } = props || {};

  useEffect(() => {
    if (!isDropdownShown && !navbarClicked) {
      setTimeout(() => {
        setZIndex?.(0);
      }, 500);
      setMakeBlur?.(false);
    }
    else {
      setZIndex?.(1);
      setMakeBlur?.(true);
    }
  }, [isDropdownShown, navbarClicked]);

  useEffect(() => {
    if(token){
      setIsUserAuthenticated(true);
    } else {
      setIsUserAuthenticated(false);
    }

    // Function to handle storage events
    const handleStorageChange = (e) => {
      if (e.key === 'persist:root') {
        try {
          const rootState = JSON.parse(e.newValue || '{}');
          const authState = JSON.parse(rootState.auth || '{}');
          const newToken = authState.token;

          if (newToken) {
            if (newToken !== token) {
              dispatch(setAuthState(authState));
            }
            setIsUserAuthenticated(true);
          } else {
            if (token) {
              dispatch(SignOut());
              navigate('/auth/sign-in', { replace: true });
            }
            setIsUserAuthenticated(false);
          }
        } catch (error) {
          console.error('Error parsing storage event:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [token, dispatch, navigate]);

  useImperativeHandle(ref, () => ({
    closeMenu() {
      if (isDropdownShown) {
        setIsDropdownShown(false);
        setMakeBlur(false);
      }
      navbarClicked && setNavbarClicked('');
    }
  }));

  let user = {};
  if (!isEmpty(parentUser)) user = parentUser;
  else user = currentUser;
  const splitedName = user?.full_name?.toUpperCase()?.split(' ') || [];
  const abbreviatedName = `${splitedName?.[0]?.[0] || ''}${splitedName?.[1]?.[0] || ''}`;
  const isOwner = user?.email == 'mike@opulent.com';

  const resetAndNavigate = async () => {
    const reducers = isOwner ? ['adminUsers'] : ['affiliate'];
    await dispatch({ type: 'RESET_APP', reducers });
    isOwner ? navigate('/admin/user') : navigate('/affiliate');
  };

  return (
    <HeaderWrapper drawerOpened={zIndex} disabled={disabled} onTop={onTop} isTransparent={isTransparent}>
      <div className="d-flex justify-content-between align-items-center h-100 header">
        {!login && !isTransparent ? '' : ''}
        {login && (
          <>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '16px' }}>
              {/* <AiOutlineMenu onClick={onClick} /> */}
              {/* <HamburgerIcon setIsDropdownShown={setIsDropdownShown} rotated={isDropdownShown} /> */}
              {/* {!isTransparent && <img src={Logo} width={35} alt="no-log" />} */}
              {/* <TabName>|</TabName>
              <TabName style={{ cursor: 'pointer' }} onClick={() => setIsDropdownShown(!isDropdownShown)}>Menu</TabName> */}
              {/* <div className="white-divider h-30" /> */}
              {/* <h1 className="mb-0 text-white">Inventory</h1> */}
            </div>
            <div className="logn-session">
              {isImpersonatedCurrentUser &&
                <Dropdown className="switch-user" onToggle={(event) => setNavbarClicked(event ? 'impersonate' : '')}>
                  <Dropdown.Toggle>
                    <div className="switch-user align-items-center">
                      <span className="icon-user fs-25 mr-4"></span>
                      <div className="user-info d-flex flex-column align-items-start grid-row-gap-4">
                        <span className="userName">Impersonated By</span>
                        <span className="email">
                          {currentUser?.email}
                        </span>
                      </div>
                      <span className="icon-switch margin-right-4 fs-14" onClick={() => {
                        dispatch(stopImpersonatingUser());
                        localStorage.removeItem('shopifyStoreName');
                        resetAndNavigate();
                      }}></span>
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu show={navbarClicked === 'impersonate'}>
                    <div className="userSwitchinfo">
                      <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center grid-column-gap-16">
                          <span className="icon-user fs-16"></span>
                          <span className="username">{currentUser?.full_name}</span>
                        </div>
                        {/* <div>
                          <div className="status inactive">Inactive</div>
                        </div> */}
                      </div>
                      <div className="login-info d-flex flex-column">
                        <span className="email">{currentUser?.email}</span>
                        {/* <span className="role color-primary fs-14 ">{currentUser?.role?.name}</span> */}
                        <span className="role color-primary fs-14">{currentUser?.company?.name}</span>

                        {/* <span className="tile color-secondary fs-14">Oliver Oil Box</span>
                        <span className="users color-secondary fs-14">Affiliate Manager<BsCheckCircleFill /><span>373 Users</span></span>
                        <span className="affilate color-secondary fs-14"> <span className="title">Affiliated to</span>  <b className="ml-4">N/A</b></span>
                        <span className="affilate color-secondary fs-14"><span className="title">Signup at</span><b>30 Apr, 2018 - 01:58:00 AM</b></span>
                        <span className="affilate color-secondary fs-14"><span className="title">Last Login</span> <b>28 Jan, 2021 - 07:34:00 PM</b></span> */}
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              }
              {/* <div className="white-divider" /> */}
              {/* {currentUser?.email == 'mike@opulent.com' && <FontAwesomeIcon icon={faUsers} className="add-margin" onClick={() => navigate('/admin/user')} />} */}
              {/* {currentUser?.role?.name !== 'Worker' && <span className="icon-graph add-margin cursor-pointer" onClick={() => navigate('/referal-users')}></span>} */}
              {/* <span className="icon-mointer fs-28 mr-31 cursor-pointer" onClick={() => window.open('https://thefbamachine-com.mykajabi.com/')}></span> */}
              {/* <div className="bell-badge cursor-pointer">
                <BsBell  />
                <div></div>
              </div> */}
              {
                isUserAuthenticated ? (
                  <Dropdown className="avatar" onToggle={(event) => setNavbarClicked(event ? 'logged-in-user' : '')}>
                    <Dropdown.Toggle>
                      <span className="fs-12">{abbreviatedName}</span>
                      <span className="arrow-box">
                        <BiChevronDown />
                      </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu show={navbarClicked === 'logged-in-user'}>
                      <div className="user-dropdown">
                        <div className="d-flex grid-column-gap-10 marginy-8">
                          <div>
                            <span className="icon-user fs-16"></span>
                          </div>
                          <div className="d-flex flex-column grid-column-2">
                            <Tooltip title={user?.full_name}>
                              <span className="username fs-14 tw-whitespace-nowrap tw-max-w-[120px] tw-truncate">{user?.full_name}</span>
                            </Tooltip>
                            <Tooltip title={user?.email}>
                              <span className="email tw-whitespace-nowrap tw-max-w-[120px] tw-truncate">{user?.email}</span>
                            </Tooltip>
                            {/* <span className="role color-secondary fs-14">{user?.role?.name}</span> */}
                            <span className="role color-secondary fs-14">{user?.company?.name}</span>
                          </div>
                        </div>
                        <hr />
                        <div className="logout grid-column-gap-10 d-flex" onClick={() => {
                          dispatch(SignOut());
                          navigate('/auth/sign-in', { replace: true });
                        }}>
                            <div>
                              <FiLogOut className="color-primary" />
                            </div>
                            <span className="tw-text-sm tw-pt-1 tw-text-foreground">Logout</span>
                        
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Link
                    to="/auth/sign-in"
                    className="btn btn-primary"
                    onClick={() => localStorage.setItem(STORAGE_KEY, JSON.stringify({ 'currentStep': 1, 'maxStep': 1 }))}
                    style={{
                      padding: '6px 16px',
                      borderRadius: '4px',
                      fontSize: '14px',
                      fontWeight: '500',
                      textDecoration: 'none',
                      transition: 'all 0.3s',
                      backgroundColor: 'hsl(217, 91%, 60%)',
                      border: '1px solid hsl(217, 91%, 60%)',
                      color: '#fff'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = 'hsl(217, 93.90%, 67.80%)';
                      e.target.style.borderColor = 'hsl(217, 93.90%, 67.80%)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = 'hsl(217, 91%, 60%)';
                      e.target.style.borderColor = 'hsl(217, 91%, 60%)';
                    }}
                  >
                    Sign In
                  </Link>
                )
              }
            </div>
          </>
        )}
      </div>

      <AnimatePresence>
        {isDropdownShown && <MenuDropDown isDropdownShown={isDropdownShown} setIsDropdownShown={setIsDropdownShown} />}
      </AnimatePresence>
    </HeaderWrapper>
  );
});

export default Header;
